var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('v-subheader',{staticClass:"pl-0",staticStyle:{"height":"20px"}},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticStyle:{"font-size":"16px"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }